export enum actionTypes {
  CURRICULUMS_SELECTA_FETCH = 'CURRICULUMS_SELECTA_FETCH',
  CURRICULUMS_SELECTA_SUCCESS = 'CURRICULUMS_SELECTA_SUCCESS',
  CURRICULUMS_SELECTA_ERROR = 'CURRICULUMS_SELECTA_ERROR',
  CURRICULUMS_SELECTA_RESET = 'CURRICULUMS_SELECTA_RESET',
}

export enum CurriculumsSelectaStatus {
  Idle,
  Loading,
  Error,
  Success,
}

export interface CurriculumSelecta {
  id: number
  nombre: string
}

export interface CurriculumsSelectaState {
  curriculumsSelectaStatus: CurriculumsSelectaStatus
  curriculumsSelecta: Array<CurriculumSelecta>
}

export interface CurriculumsSelectaFetch {
  type: typeof actionTypes.CURRICULUMS_SELECTA_FETCH
  payload: null
}

export interface CurriculumsSelectaSuccess {
  type: typeof actionTypes.CURRICULUMS_SELECTA_SUCCESS
  payload: Array<CurriculumSelecta>
}

export interface CurriculumsSelectaError {
  type: typeof actionTypes.CURRICULUMS_SELECTA_ERROR
  payload: null
}

export interface CurriculumsSelectaReset {
  type: typeof actionTypes.CURRICULUMS_SELECTA_RESET
  payload: null
}

export type CurriculumsSelectaActions =
  | CurriculumsSelectaFetch
  | CurriculumsSelectaSuccess
  | CurriculumsSelectaError
  | CurriculumsSelectaReset

export const initialState: CurriculumsSelectaState = {
  curriculumsSelectaStatus: CurriculumsSelectaStatus.Idle,
  curriculumsSelecta: [],
}
